import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ConfirmModalData } from '../../models';

@Injectable({ providedIn: 'root' })
export class ConfirmModalService {
    private _visible = false;
    private _data: ConfirmModalData = { title: '', content: '' };
    private readonly resultSubject = new Subject<boolean>();

    /** Whether the confirmation modal is currently shown. */
    get visible(): boolean {
        return this._visible;
    }

    /** Current modal content passed to the modal component. */
    get data(): ConfirmModalData {
        return this._data;
    }

    /**
     * Opens the confirmation modal (hosted in the header).
     * @returns An observable that emits once when the user closes the modal:
     *   `true` when confirmed, `false` when cancelled or closed.
     */
    open(data: ConfirmModalData): Observable<boolean> {
        this._data = { ...data };
        this._visible = true;
        return this.resultSubject.pipe(take(1));
    }

    /**
     * Closes the modal and notifies the current subscriber.
     * @param result - `true` if the user confirmed, `false` if cancelled.
     */
    close(result: boolean): void {
        this._visible = false;
        this.resultSubject.next(result);
    }
}
